import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

export function InviteBlastCard() {
  const [s, setS] = useState(null);
  const [ch, setCh] = useState({ email: true, text: true });
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/weddings/mine/portal-invites").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!s) return null;
  async function send(resend) {
    if (resend && !window.confirm(`Send the portal invite again to ${s.can_resend} guest${s.can_resend === 1 ? " who hasn't" : "s who haven't"} made a login yet?`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/weddings/mine/portal-invites", { ...ch, resend });
      if (data.mocked) toast.message(`Email and text are switched off, so ${data.mocked} invite${data.mocked === 1 ? " wasn't" : "s weren't"} delivered. Turn them on in Admin → Integrations.`);
      if (data.sent) toast.success(`Invite sent to ${data.sent} guest${data.sent === 1 ? "" : "s"}`);
      if (data.failed) toast.error(`${data.failed} invite${data.failed === 1 ? "" : "s"} couldn't be sent`);
      load();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  }
  return (
    <div className="bg-white border border-[var(--line)] rounded-2xl p-5" data-testid="invite-blast-card">
      <h3 className="font-serif text-xl mb-1">Invite guests to their portal</h3>
      <p className="text-xs text-[var(--muted)] mb-3">Each guest gets their own signup link by email and text, so they can see their seat and chat with you.</p>
      <div className="flex flex-wrap gap-4 text-sm mb-3" data-testid="invite-blast-stats">
        <span><b>{s.linked}</b> of {s.total} have a login</span>
        <span><b data-testid="invite-not-invited">{s.not_invited}</b> not invited yet</span>
        {s.no_contact > 0 && <span className="text-[var(--muted)]">{s.no_contact} have no email or phone</span>}
      </div>
      <div className="flex flex-wrap items-center gap-4">
        <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={ch.email} onChange={(e) => setCh({ ...ch, email: e.target.checked })} data-testid="invite-email" /> Email</label>
        <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={ch.text} onChange={(e) => setCh({ ...ch, text: e.target.checked })} data-testid="invite-text" /> Text</label>
        <button onClick={() => send(false)} disabled={busy || !s.not_invited || (!ch.email && !ch.text)} className="btn-gold text-xs" data-testid="invite-send">{busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Send className="w-3 h-3" />} Send to {s.not_invited}</button>
        {s.can_resend > s.not_invited && <button onClick={() => send(true)} disabled={busy} className="text-xs underline" data-testid="invite-resend">Resend to everyone without a login ({s.can_resend})</button>}
      </div>
    </div>
  );
}
